import { format } from "date-fns";

import type { TimeStamp } from "pages/AccountSettlementHistoryOrderId/types/TimeStamp";
import type { useTranslation } from "react-i18next";

export const getReleaseDate = (
  timeStamp: TimeStamp,
  t: ReturnType<typeof useTranslation>["t"]
): {
  openDate: string;
  openTime: string;
} => {
  const targetDatetime = new Date(timeStamp.seconds * 1000);

  const date = format(targetDatetime, "M/d");
  const dayDisplay = t(
    `common.string.dayOfWeek.${format(targetDatetime, "E")}`
  );

  const openDate = `${date}(${dayDisplay})`;
  const openTime = format(targetDatetime, "HH:mm");

  return { openDate, openTime };
};
